module.exports = __webpack_public_path__ + "img/grend_6.5906f8a5.jpg";